import { SvgIcon } from '@mui/material'

const SvgSubstitute = (props) => (
  <SvgIcon viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" name="SvgSubstitute" {...props}>
    <style>{'.substitute_svg__st1{fill:#467b5b}.substitute_svg__st3{fill:#d32f2f}'}</style>
    <path
      d="M59.54 44.397L40.829 29.664a.817.817 0 00-1.321.641v9.497H22.501a.942.942 0 00-.075.004c-2.546.016-7.19-.018-11.552-2.775-2.169-1.371-3.17-2.762-3.178-2.774-.463-.661-1.507-.316-1.485.49.004.156.125 3.872 2.021 7.638 1.778 3.532 5.491 7.742 13.086 7.742H39.36v9.055a.817.817 0 001.306.653l18.858-14.144a.812.812 0 00.326-.643.814.814 0 00-.31-.651z"
      fill="#64b082"
    />
    <path
      className="substitute_svg__st1"
      d="M40.666 57.836a.817.817 0 01-1.306-.653v2a.817.817 0 001.306.653l18.858-14.144-18.858 12.144zM39.36 48.128H21.318c-7.595 0-11.308-4.21-13.086-7.742-1.179-2.342-1.671-4.663-1.876-6.123a.797.797 0 00-.145.485c.004.156.125 3.872 2.021 7.638 1.778 3.532 5.492 7.742 13.086 7.742H39.36v-2z"
    />
    <path
      d="M55.768 21.614c-1.778-3.532-5.492-7.742-13.087-7.742H24.639V4.817a.817.817 0 00-1.306-.653L4.475 18.308a.816.816 0 00-.015 1.294l18.711 14.733a.817.817 0 001.321-.641v-9.497h18.189c5.009 0 8.444 1.507 10.444 2.771 2.169 1.371 3.17 2.762 3.178 2.774.462.661 1.507.316 1.485-.49-.004-.156-.124-3.872-2.02-7.638z"
      fill="#f44336"
    />
    <g>
      <path
        className="substitute_svg__st3"
        d="M56.304 27.742c-.008-.012-1.01-1.403-3.178-2.774-2-1.264-5.435-2.771-10.444-2.771h-18.19v2h18.189c5.009 0 8.444 1.507 10.444 2.771 2.169 1.371 3.17 2.763 3.178 2.774.462.661 1.507.316 1.485-.49-.002-.059-.02-.628-.145-1.515-.297.426-.986.51-1.339.005zM23.171 32.336a.817.817 0 001.321-.641v2a.816.816 0 01-1.321.641L4.46 19.603l18.711 12.733z"
      />
    </g>
  </SvgIcon>
)

export default SvgSubstitute
